export default __webpack_public_path__ + "media/images/icons/portfolio-plus-divide-125bd94c98e7675799f28b826904cf18.svg";